[
  {
    "title": "Camila Valderrama",
    "img": "https://avatars.githubusercontent.com/u/145812193?v=4",
    "linkedin": "https://www.linkedin.com/in/camilavalderrama",
    "location": "San Fernando del Valle de Catamarca, Catamarca.",
    "github": "https://github.com/camila-valderrama",
    "portfolio": "https://github.com/camila-valderrama",
    "description": "Desarrolladora Web Full Stack con conocimientos en HTML, CSS, JavaScript, Python, SQL y Git."
  },
  {
    "title": "Marina Benitez",
    "img": "https://raw.githubusercontent.com/d3vh4n5/CaC-Fullstack-Node-Grupo10/92691eec0b889e64f32c1729af7beec9aea8c518/assets/img/woman.svg",
    "linkedin": "",
    "location": "Moron, Bs As, Argentina",
    "github": "https://github.com/MarinaMaruka",
    "portfolio": "",
    "description": "Desarrolladora web Full Stack Node.js. Manejo HTML, CSS y JavaScript"
  },
  {
    "title": "Hugo Terrile",
    "img": "https://media.licdn.com/dms/image/D4E03AQFgr_-YLhiGSw/profile-displayphoto-shrink_100_100/0/1680446251262?e=1725494400&v=beta&t=E_Rd00exDw1jCntz53BHuutipLu0FYerhbf6YtEGWlk",
    "linkedin": "https://www.linkedin.com/in/hugo-terrile-it/",
    "location": "Wembley, Inglaterra, Reino Unido",
    "github": "https://github.com/hterrilex",
    "portfolio": "",
    "description": "FullStack Node || Geo Data Analyst - Dev Python"
  },
  {
    "title": "Juan Angel Basgal",
    "img": "https://avatars.githubusercontent.com/u/86476526?v=4",
    "linkedin": "https://www.linkedin.com/in/juanangelbasgall/",
    "location": "Campana, Bs As, Argentina",
    "github": "https://github.com/d3vh4n5",
    "portfolio": "https://d3vh4n5.com.ar/",
    "description": "Desarrollador FullStack - Node | Js - Ts | PHP | Python || React | Vue"
  }
]